import Router from '@/router'
import { requestTsp } from './mockTsp'
import { RequestDataParams } from '#/bridge'

export default {
  appBrand: 10,
  userInfo: {
    isCarOwner: true,
    username: '13520812295',
    email: '1091354551895883777@u.com',
    phone: '13520812295',
    mobilePhone: '13520812295',
    nickName: 'jqliu',
    userPicture: 'http://haval-sso.haval.com.cn/avatar/8af99e646ece4547acedb4730067e7d2',
    sex: '',
    userId: 'U1091354551895883776',
    beanId: '3150722729173819392',
    accessToken:
      'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NTkzMDgzMTYsImNoYW5uZWwiOiJDRjBGMDRBRC01NzQ2LTRDOUQtOTRFQy01NTY5NkVBQjk2MjkiLCJqd3RfdHlwZSI6MSwiand0VHlwZSI6MSwia2V5IjoiYmVhbi1hcHAtdXNlci1rZXkiLCJyb2xlQ29kZSI6ImFkbWluIiwic3NvSWQiOiJVMTA5MTM1NDU1MTg5NTg4Mzc3NiIsImd3bVJzIjoiMiIsImd3bUJyYW5kIjoiQ0NHMDAxIiwiZ3dJZCI6IjMxNTA3MjI3MjkxNzM4MTkzOTIiLCJpYXQiOjE3NTg3MDM1MTYsImlzcyI6Imd3dCBTZXJ2ZXIiLCJiZWFuSWQiOiIzMTUwNzIyNzI5MTczODE5MzkyIn0.jqf62tF-WoZ2UOGzjhlAavHbXxJBSYjXMM_eYG8TIYEJM7ZdpIoPubBwwQO0NxzYGvFcSdqjpVK0YzUq95D3ens4ya0GsxFhx-Up15qkjvPOQ78mpEfvbcGtaoWVOxSLUt6XPCD13dX-Gy_Fz5VhdkuMVp_HN67zDx3mfnXBuc3VAoGp_yNjoYjC05yT-8KOQa76zP_neg7gMLoxbLiLg3TEBnjmiFQeEcVMKCXkgQpuXyLTnYHafDG3eG_SC-vP6dW4D_CGp76J67iYGL-FK1eoHAYBCj9t9DE_Mb6MBrBIsQ9yucQRhAZS8U0lclMt7aAXguZXuhLNKj0Ah7CdzQ',
    ssoToken: 'acb1e9e432044e76afd0d5f513119bd9',
    ptToken: 'cfc6f2644a48592b7e84d8b655d58c84',
    ssoId: 'U1091354551895883776',
    gToken:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYmYiOjE3MzE2NjQzNzcsInNvdXJjZUFwcCI6IkdXTSIsInNvdXJjZVR5cGUiOiJBTkRST0lEIiwiYXBwSWQiOiJHV00tQVBQLUFORFJPSUQtVEVTVC0xMDAwMTgiLCJwdFRva2VuIjoiY2ZjNmYyNjQ0YTQ4NTkyYjdlODRkOGI2NTVkNThjODQiLCJleHAiOjE3MzIyNjkxNzcsImlhdCI6MTczMTY2NDM3NywidXNlcklkIjoiVTEwOTEzNTQ1NTE4OTU4ODM3NzYiLCJkZXZpY2VJZCI6ImZiYzY4YjkwZGE1NTRlMjE5ZThmOTRmYTlmMGRjMjQ4In0.2rMzVsx8q539CzXzILkb7od4xzyexAQFxOsI-Om8rpw',
    tokenId: 'fb483f256c274897acc9122bcb4eeb65',
  },
  locationInfo: {
    longitude: 22,
    latitude: 22,
    city: '北京',
    province: '北京市',
    district: '亦庄开发区',
    street: '亦城时代',
    number: '111',
    adCode: '1111',
  },
  carInfo: {
    beantechToken:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJnd21CcmFuZCI6IkNDRzAwMSIsImtleSI6ImJlYW4tYXBwLXVzZXIta2V5Iiwiand0X3R5cGUiOjEsImp3dFR5cGUiOjEsImJlYW5JZCI6IjI5OTY3NDE0MDQyMDQ5OTA0NjQiLCJjaGFubmVsIjoiZmJjNjhiOTBkYTU1NGUyMTllOGY5NGZhOWYwZGMyNDgiLCJpYXQiOjE3MjQ2NTU3NDMsImlzcyI6Imd3dCBTZXJ2ZXIiLCJnd21ScyI6IjIiLCJleHAiOjE3MjUyNjA1NDMsInNzb0lkIjoiVTk0MDk4MjE2NDI2OTQzMjgzMiIsImd3SWQiOiIyOTk2NzQxNDA0MjA0OTkwNDY0Iiwicm9sZUNvZGUiOiJhZG1pbiJ9.5xUpeuBQmUgUFbCS49khHw_AA5RvnMZibyk8F_rOWHotvnmdLCL3i2G7IsYMMAkN-GoTiSVDB9rrytahRjbzluRPfLju-TLaeM1o4Pv50-FJ0TUwU0sxHbAGAwGxaQsEWY9PY59IC8RqcC2VCMsUHE2KyNETnJyocSWyR4INN-msoyDy-e85Nx7xA0H4-nX8b-HY_D0I1oqfwvNyUeFtKugw96vnl-A0cqbT1rneBWUqAio4SlG0goLn8rob-X8YnpNm9SmRGELqRNabK04nBs6LW0dhGUpmqahNUPpQX2HweINhdLTNADBuvEX5HHe_2DHkRPgUuYHJDliC-aoDHw',
    ssoToken: 'b448a25a42f54fa78fc9806310e57d1c',
    navinfoToken: '857f3021fd634df98968f966cb71e9f6',
    vin: 'LGWVEPKR6S3257385',
    canSignalType: '',
    styleName: '高配-黑',
    modelName: '巡航CCS001',
    belongPlatform: 'gtsp',
    vtype: '巡航CCS001',
    originalVTypeName: 'CCTESTMC01A0002',
    licenseNumber: '',
    brandName: '灵魂',
    ownership: '0',
  },
  getStatusBarHeight: '24',
  pushView: (data: { page: string; hiddenNav: boolean }) => {
    let url = data.page
    if (/^http(s)?/gi.test(url)) {
      url = url.replace(window.location.origin, '')
      url = url.replace(/^#/, '')
    }
    Router.push(url)

    return {}
  },
  pushViewGwm: (data: { page: string; hiddenNav: boolean }) => {
    let url = data.page
    if (/^http(s)?/gi.test(url)) {
      url = url.replace(window.location.origin, '')
      url = url.replace(/^#/, '')
    }
    Router.push(url)

    return {}
  },
  pushNativeGwm: (data: { url: string }) => {
    let url = data.url
    if (/^http(s)?/gi.test(url)) {
      url = url.replace(window.location.origin, '')
      url = url.replace(/^#/, '')
    }
    Router.push(url)

    return {}
  },
  popView: () => {
    window.history.back()

    return {}
  },
  closeView: () => {
    window.history.back()

    return {}
  },
  requestData: (config: RequestDataParams) => {
    return requestTsp(config)
  },
}
